import { render } from "./TelaResposta.vue?vue&type=template&id=210cce29&scoped=true&ts=true"
import script from "./TelaResposta.vue?vue&type=script&lang=ts"
export * from "./TelaResposta.vue?vue&type=script&lang=ts"

import "./TelaResposta.vue?vue&type=style&index=0&id=210cce29&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210cce29"]])

export default __exports__